import { render, staticRenderFns } from "./WtAddFriendButton.vue?vue&type=template&id=25d8c8fa&scoped=true&lang=pug&"
import script from "./WtAddFriendButton.vue?vue&type=script&lang=js&"
export * from "./WtAddFriendButton.vue?vue&type=script&lang=js&"
import style0 from "./WtAddFriendButton.vue?vue&type=style&index=0&id=25d8c8fa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d8c8fa",
  null
  
)

export default component.exports